import React from 'react';
import { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { FORMS } from '../../schemas/stepMap';
import { useProperty } from '../../hooks/useProperty';
import { useSteps } from '../../hooks/useSteps';
import BackForwardButtons from '../../components/buttons/BackForwardButtons';
import FormBuilder from '../../components/formBuilder';
import PurchaseKeyMetrics from './PurchaseKeyMetrics';
import PurchaseProjectionsSummary from './PurchaseProjectionsSummary';
import PurchaseSummaryOverview from './PurchaseSummaryOverview';

export default function PurchaseSummaryView() {
  const { propertyData } = useProperty();

  const { prev, next } = useSteps();
  const { pathname } = useLocation();
  const sharing = pathname.includes('sharing');

  const purchaseWorksheet = FORMS.purchaseAnalysisSimple;
  const purchaseWorksheetSchema = purchaseWorksheet.schema;

  if (!propertyData.purchaseWorksheetSubmitted) {
    return (
      <div className="w-full flex flex-col items-center justify-center mt-36">
        <h2 className="mb-6 text-xl font-medium text-primary">
          No Purchase Analysis Created
        </h2>
        {!sharing && (
          <p className="mb-72 w-2/3 text-center">
            Once you add property details in the{' '}
            <Link
              to="../../purchase-worksheet"
              className="font-medium text-primary hover:text-primary-700 focus:text-primary-700"
            >
              purchase worksheet
            </Link>
            , you will be able to see your property analysis here.
          </p>
        )}
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>PropertyCast.io - Purchase Analysis</title>
      </Helmet>

      <main>
        <div id="page-summary" className="space-y-10 my-8 bg-primary-50">
          <PurchaseSummaryOverview propertyData={propertyData} />

          <PurchaseKeyMetrics propertyData={propertyData} />

          <FormBuilder
            formType={purchaseWorksheet.formType}
            calculationsSchema={purchaseWorksheetSchema}
            beforeData={propertyData}
            keyMetricsSchema={purchaseWorksheet.keyMetrics}
            keyMetricsData={propertyData}
          />

          <PurchaseProjectionsSummary propertyData={propertyData} />
        </div>
        <BackForwardButtons prev={prev} next={next} />
      </main>
    </>
  );
}
